module.exports = __webpack_public_path__ + "img/OMG_03.63705585.png";